'use strict';

import React from 'react';

class FooterComponent extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var footerStyle = {
      padding: '1em',
      borderTop: '5px groove whitesmoke',
      margeTop: '2em',
      color: 'white'
    }
    var linkStyle = {
      color: 'white'
    }


    return (
      <div className='container-fluid text-center' style={footerStyle}>
        <p><div className="lead">Thanks for visiting!</div></p>
        <p>For questions, feedback, or access to our API, Email <a style={linkStyle} href="mailto:hello@metadroner.com?Subject=Hello" target="_top">hello@metadroner.com</a></p>
        <p>API docs available at: <a style={linkStyle} href="http://docs.metadroner.apiary.io/#">docs.metadroner.apiary.io</a></p>
      </div>
    )
  }
}


FooterComponent.displayName = 'FooterComponent';

export default FooterComponent;



/** WEBPACK FOOTER **
 ** ./src/components/FooterComponent.js
 **/